function PipesLevers() {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1920.000000 200.000000"
            preserveAspectRatio="xMidYMid meet"
            className='pipes-levers'
            >

            <g transform="translate(10.000000,200.000000) scale(0.100000,-0.100000)"
            fill="#ea7575" stroke="none">
<path d="M2695 1841 c-105 -49 -152 -167 -106 -266 34 -74 111 -125 189 -125
56 0 134 43 168 92 25 36 29 50 29 113 0 63 -4 77 -29 113 -34 50 -112 92
-170 92 -23 0 -59 -9 -81 -19z m161 -46 l26 -17 -38 -39 c-49 -50 -85 -52
-131 -7 -41 40 -41 55 0 74 39 18 107 13 143 -11z m-164 -82 c21 -20 38 -46
38 -57 0 -20 -66 -96 -83 -96 -12 0 -37 64 -37 95 0 29 25 95 37 95 4 0 24
-17 45 -37z m236 6 c17 -32 10 -125 -11 -147 -16 -15 -19 -14 -52 19 -50 49
-51 72 -8 120 39 43 51 45 71 8z m-134 -48 c4 -5 -4 -7 -16 -3 -18 4 -20 2
-15 -18 4 -16 3 -20 -5 -12 -6 6 -8 18 -5 26 7 17 32 21 41 7z m6 -31 c0 -5
-5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m44 -69 l38
-39 -26 -17 c-37 -25 -96 -30 -139 -12 -20 9 -37 22 -37 29 0 6 14 27 32 45
45 47 82 45 132 -6z"/>
<path d="M16871 1806 c-8 -9 -11 -67 -9 -186 3 -152 5 -174 21 -184 12 -8 22
-8 35 0 15 10 17 32 20 184 3 178 -2 200 -38 200 -10 0 -23 -6 -29 -14z"/>
            </g>
            </svg>
    )
}

export default PipesLevers;